import React from 'react';
import { Phone, Calendar } from 'lucide-react';
export function CtaBand() {
  return <section className="bg-brand-red py-16 relative overflow-hidden" data-id="element-18">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-19"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-20">
        <h2 className="text-4xl md:text-5xl font-display font-bold text-white uppercase mb-6" data-id="element-21">
          Got a leak? We will fix it today.
        </h2>
        <p className="text-white/90 text-xl mb-10 max-w-2xl mx-auto" data-id="element-22">
          Don't let plumbing problems disrupt your life. Our expert team is
          standing by 24/7 to provide fast, reliable solutions.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-23">
          <a href="tel:7026425352" className="flex items-center justify-center gap-2 bg-white text-brand-red hover:bg-gray-100 px-8 py-4 rounded-md font-bold text-lg transition-colors uppercase tracking-wide w-full sm:w-auto shadow-lg" data-id="element-24">
            <Phone className="w-6 h-6" data-id="element-25" />
            <span data-id="element-26">Call (702) 642-5352</span>
          </a>
          <a href="#contact" className="flex items-center justify-center gap-2 bg-transparent text-white border-2 border-white hover:bg-white/10 px-8 py-4 rounded-md font-bold text-lg transition-colors uppercase tracking-wide w-full sm:w-auto" data-id="element-27">
            <Calendar className="w-6 h-6" data-id="element-28" />
            <span data-id="element-29">Schedule Online</span>
          </a>
        </div>
      </div>
    </section>;
}